import { useState } from 'react'
import { Link } from 'react-router';

export interface Heading {
	id: string
	text: string | null
	heading: string | null
}
const TableOfContents = (props: {
	headings: Heading[] | []
	relatedProcedures?: Boolean
	adminOffices?: Boolean
	otherSections: Heading[]
}) => {
	const { headings, otherSections } = props
	const [activeId, setActiveId] = useState('')
	//const observer = useRef<IntersectionObserver | null>(null)

	// Create new objects based on otherSections
	const updatedHeadings: Heading[] = otherSections.map(item => ({
		id: item.id,
		text: item.text,
		heading: item.heading,
	}))

	// Merge the existing headings array with the updatedHeadings array
	const mergedHeadings: Heading[] = [...headings, ...updatedHeadings]

	/* useEffect(() => {
		const handleObserver = (entries: any) => {
			entries.forEach((entry: any) => {
				if (entry?.isIntersecting) {
					setActiveId(entry.target.id)
				}
			})
		}

		observer.current = new IntersectionObserver(handleObserver, {
			rootMargin: '-20% 0% -35% 0px',
		})

		const elements = document.querySelectorAll('h2, h3')
		elements.forEach(elem => observer.current?.observe(elem))
		return () => observer.current?.disconnect()
	}, [headings]) */

	const handleLinkClick = (id: string) => {
		const targetElement = document.getElementById(id)
		if (targetElement) {
			const yOffset = -80 // 80px above the element
			const y =
				targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
			window.scrollTo({ top: y, behavior: 'smooth' })
			setActiveId(id)
		}
	}

	return (
		<>
			{headings.length > 0 && (
				<>
					<div className="space-y-2">
						<h3 className="mb-3 text-xs font-semibold uppercase text-amber-700">
							En esta página
						</h3>
						<ul>
							{mergedHeadings.map(({ text, id, heading }) => (
								<li
									key={id + '_' + heading}
									className={'pb-1 ' + (heading === 'h3' ? 'pl-4' : '')}
								>
									<Link
										className={
											'text-md  hover:text-primary ' +
											(activeId === id
												? 'font-bold text-gray-900'
												: 'font-semibold  text-gray-600')
										}
										to={`#${id}`}
										onClick={(e: any) => {
											e.preventDefault()
											//@ts-ignore
											handleLinkClick(id)
										}}
									>
										{text}
									</Link>
								</li>
							))}
						</ul>
					</div>
				</>
			)}
		</>
	)
}

export { TableOfContents }
